import styles from './sidebar.module.scss'

export function Sidebar({ children }) {
  return <aside className={styles.sidebar}>{children}</aside>
}
